








































import { MessagePlugin } from 'tdesign-vue';
import _ from 'lodash';
import {
  computed,
  defineComponent,
  onMounted,
  onUnmounted,
  reactive,
  ref,
  toRefs,
  getCurrentInstance,
} from '@vue/composition-api';
import i18n, { i18n_t } from '@/locales/i18n';
import ipc from '@/renderer/scripts/utils/ipc';
type failInfoItem = {
  id: number;
  msg: string;
  path?: string;
};
type FailInfo = {
  list: failInfoItem[];
  type: string;
};
const failInfo = reactive<FailInfo>({
  list: [],
  type: '',
});
export default defineComponent({
  setup(props: any, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const innerShow = ref(false);
    const showErrTip = ref(false);
    const loadingList = ref(false);
    const columns = ref();
    const columnsRestore: Array<any> = [
      {
        colKey: 'path',
        title: i18n_t('文件名'),
        ellipsis: { attach: 'body' },
      },
      {
        colKey: 'msg',
        title: i18n_t('错误原因'),
        ellipsis: { attach: 'body' },
        width: 350,
      },
      {
        colKey: 'op',
        title: i18n_t('操作'),
        width: 100,
      },
    ];
    const columnsCopy = [
      {
        colKey: 'copyFrom',
        title: i18n_t('原路径'),
        ellipsis: { attach: 'body' },
      },
      {
        colKey: 'to',
        title: i18n_t('目标路径'),
        ellipsis: { attach: 'body' },
      },
      {
        colKey: 'msg',
        title: i18n_t('错误原因'),
        ellipsis: { attach: 'body' },
      },
      {
        colKey: 'op',
        title: i18n_t('操作'),
      },
    ];
    const columnsUpload = [
      {
        colKey: 'path',
        title: i18n_t('路径'),
        ellipsis: { attach: 'body' },
      },
      {
        colKey: 'msg',
        title: i18n_t('错误原因'),
        ellipsis: { attach: 'body' },
      },
    ];
    const columnsMove = _.cloneDeep(columnsCopy).map((item: any) => {
      if (item.colKey === 'copyFrom') {
        item.colKey = 'from';
      }
      return item;
    });
    const handleRetry = (command: string, item?: any) => {
      if (!item && failInfo.list.length > 1) loadingList.value = true; // list单个存在时无需loading
      switch (command) {
        case 'restore':
          {
            const RecycledItemId = item ? [item.id] : failInfo.list.map(item => item.id);
            ipc.emit(ipc.RENDERER_EVENTS_MAP.RETRY_RESTORE, RecycledItemId, {
              data: failInfo.list,
            });
          }
          break;
        case 'copy':
          {
            const data = item ? [item] : failInfo.list;
            ipc.emit(ipc.RENDERER_EVENTS_MAP.RETRY_COPY, data);
          }
          break;
        case 'move':
          {
            const data = item ? [item] : failInfo.list;
            ipc.emit(ipc.RENDERER_EVENTS_MAP.RETRY_MOVE, data);
          }
          break;
        case 'delete':
          {
            const data = item ? [item] : failInfo.list;
            ipc.emit(ipc.RENDERER_EVENTS_MAP.RETRY_DELETE, data);
          }
          break;
        default:
          break;
      }
    };
    const showErrDetail = () => {
      showErrTip.value = false;
      innerShow.value = true;
    };
    const errDeal = (data: FailInfo) => {
      MessagePlugin.closeAll();
      loadingList.value = false;
      if (!innerShow.value) showErrTip.value = true;
      failInfo.list = data.list;
      failInfo.type = data.type;
      if (data.type === 'restore' || data.type === 'delete') {
        columns.value = columnsRestore;
      } else if (data.type === 'copy') {
        columns.value = columnsCopy;
      } else if (data.type === 'move') {
        columns.value = columnsMove;
      } else if (['upload', 'download'].includes(data.type)) {
        columns.value = columnsUpload;
      }
    };
    const delItem = (id: number) => {
      loadingList.value = false;
      if (!innerShow.value) return;
      failInfo.list = failInfo.list.filter((item: failInfoItem) => item.id !== id);
    };
    const clear = () => {
      loadingList.value = false;
      if (!innerShow.value) return;
      failInfo.list = [];
    };
    const errListClose = () => {
      failInfo.type === 'restore' && ipc.emit(ipc.RENDERER_EVENTS_MAP.RECYCLE_REFRESH);
    };
    onMounted(() => {
      ipc.on(ipc.RENDERER_EVENTS_MAP.ERRINFO_SHOW, errDeal);
      ipc.on(ipc.RENDERER_EVENTS_MAP.ERR_LIST_DEL, delItem);
      ipc.on(ipc.RENDERER_EVENTS_MAP.ERR_LIST_CLEAR, clear);
    });
    onUnmounted(() => {
      ipc.off(ipc.RENDERER_EVENTS_MAP.ERRINFO_SHOW, errDeal);
      ipc.off(ipc.RENDERER_EVENTS_MAP.ERR_LIST_DEL, delItem);
      ipc.off(ipc.RENDERER_EVENTS_MAP.ERR_LIST_CLEAR, clear);
    });
    return {
      innerShow,
      columns,
      loadingList,
      failInfo,
      handleRetry,
      showErrDetail,
      showErrTip,
      errListClose,
    };
  },
});
